// extracted by mini-css-extract-plugin
module.exports = {"label":"Filter_label__PZpfB","input":"Filter_input__wsFUg"};